<template lang="pug">
  LayoutDefault
    .fixedlayout
      .fixedlayout--body
        .card.fixedlayout--iframe
          iframe#iframeScreener(:src="iframeUrl", frameborder="0")

</template>



<script>
  import { mapState } from 'vuex';

  export default {
    name: 'screener',

    data() {
      return {
        resizeInterval: null,
        isDevelopment: process.env.VUE_APP_ENVIRONMENT === 'development',
      }
    },

    computed: {
      ...mapState('auth', [
        'msToken'
      ]),

      iframeUrl() {
        if(this.isDevelopment) {
          return `http://localhost:3100/iframes/screener.html?token=${this.msToken}`;
        } else {
          return `https://einvest.affinhwang.com/ms-iframe-screener?token=${this.msToken}`;
        }
      }
    },
  }

</script>




<style lang="scss">
  #iframeScreener {
    width: 100%; 
    height: 100%;
  }
</style>
